import { render } from "./ConsumptionGauge.vue?vue&type=template&id=24fad00f"
import script from "./ConsumptionGauge.vue?vue&type=script&lang=js"
export * from "./ConsumptionGauge.vue?vue&type=script&lang=js"

import "./ConsumptionGauge.vue?vue&type=style&index=0&id=24fad00f&lang=scss"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__